import { doc, onSnapshot, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

export function subscribeToSellerRatingAggregate(sellerUserId, callback) {
  return onSnapshot(doc(db, "sellerRatingAggregates", sellerUserId), (snap) => {
    callback(snap.exists() ? snap.data() : { ratingSum: 0, ratingCount: 0, ratingAverage: 0 });
  });
}

export function subscribeToMyListingRating(listingId, raterUserId, callback) {
  return onSnapshot(doc(db, "listings", listingId, "sellerRatings", raterUserId), (snap) => {
    callback(snap.exists() ? snap.data().rating : 0);
  });
}

export async function submitSellerRating(listingId, sellerUserId, raterUserId, rating) {
  const ratingDocRef = doc(db, "listings", listingId, "sellerRatings", raterUserId);
  const aggregateRef = doc(db, "sellerRatingAggregates", sellerUserId);

  await runTransaction(db, async (tx) => {
    const [ratingSnap, aggregateSnap] = await Promise.all([
      tx.get(ratingDocRef),
      tx.get(aggregateRef),
    ]);

    const prevRating = ratingSnap.exists() ? ratingSnap.data().rating : 0;
    const current = aggregateSnap.exists() ? aggregateSnap.data() : { ratingSum: 0, ratingCount: 0 };

    let ratingSum = current.ratingSum || 0;
    let ratingCount = current.ratingCount || 0;

    if (prevRating === 0) {
      ratingSum += rating;
      ratingCount += 1;
    } else {
      ratingSum += rating - prevRating;
    }

    const ratingAverage = ratingCount > 0 ? ratingSum / ratingCount : 0;

    tx.set(aggregateRef, {
      sellerUserId, ratingSum, ratingCount, ratingAverage, updatedAt: serverTimestamp(),
    }, { merge: true });

    tx.set(ratingDocRef, {
      listingId, sellerUserId, raterUserId, rating, updatedAt: serverTimestamp(),
    }, { merge: true });
  });
}
